import React from 'react';
import { Box, Paper, Typography, Button } from '@mui/material';
import { useAnalysisResults } from '../hooks/useAnalysisResults';

export const AnalysisResults: React.FC = () => {
  const { results, hasResults } = useAnalysisResults();

  if (!hasResults) {
    return null;
  }

  const commonButtonStyles = {
    justifyContent: 'flex-start',
    px: 2,
    py: 1.5,
    height: '44px',
    minHeight: '44px',
    borderRadius: '8px',
    color: 'white',
    textTransform: 'none',
    lineHeight: 1.2,
    whiteSpace: 'nowrap',
    backgroundColor: '#1B2B3A',
    borderColor: '#1B2B3A',
    '&.Mui-disabled': {
      backgroundColor: '#1B2B3A',
      color: 'white',
    },
    '&:hover': {
      backgroundColor: '#1B2B3A',
      borderColor: '#1B2B3A',
    }
  };

  return (
    <Paper
      elevation={0}
      sx={{
        mt: 3,
        p: 4,
        backgroundColor: '#243B53',
        borderRadius: '12px',
        color: 'white',
      }}
    >
      <Typography variant="h6" sx={{ mb: 3, color: 'white', fontWeight: 500 }}>
        Analysis Results
      </Typography>

      {results.map(({ title, content }) => (
        <Box key={title} sx={{ mb: 4 }}>
          <Typography sx={{ mb: 2, fontWeight: 500 }}>
            {title}
          </Typography>
          {(title === 'Sender Bias' || title === 'Content Biases') ? (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              {Array.isArray(content) && content.map((item, index) => (
                <Button
                  key={index}
                  variant="contained"
                  disabled
                  sx={commonButtonStyles}
                >
                  {item}
                </Button>
              ))}
            </Box>
          ) : (
            Array.isArray(content) ? (
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                {content.map((line, index) => (
                  <Typography key={index} sx={{ color: 'white' }}>
                    {line}
                  </Typography>
                ))}
              </Box>
            ) : (
              <Typography sx={{ color: 'white' }}>
                {content}
              </Typography>
            )
          )}
        </Box>
      ))}
    </Paper>
  );
}; 